import { render, staticRenderFns } from "./HubblePlotLegend.vue?vue&type=template&id=f0ea7132&scoped=true"
import script from "./HubblePlotLegend.vue?vue&type=script&lang=ts"
export * from "./HubblePlotLegend.vue?vue&type=script&lang=ts"
import style0 from "./HubblePlotLegend.vue?vue&type=style&index=0&id=f0ea7132&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ea7132",
  null
  
)

export default component.exports